import classnames from 'classnames';
import { FC, HTMLProps, useEffect, useRef } from 'react';

type TableRowCheckboxProps = {
  indeterminate?: boolean;
} & HTMLProps<HTMLInputElement>;

const TableRowCheckbox: FC<TableRowCheckboxProps> = ({
  indeterminate,
  ...rest
}) => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (typeof indeterminate === 'boolean' && ref?.current) {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={classnames(
        'size-4 rounded border-gray-300 text-sky-900 focus:ring-2 focus:ring-sky-800',
      )}
      {...rest}
    />
  );
};

export default TableRowCheckbox;
